export default __webpack_public_path__ + "static/media/neige.7a2becfb.jpg";